import { fetchBingoId } from '@/shared/composables/bingo/store-context';
import { storeCountryCode } from '@/shared/utils/country';

const bingoLinkSelector = '#header-bingo-link';
const hiddenClass = 'hidden';
const visibleClass = 'flex';

export const initHeaderBingoLink = async (): Promise<void> => {
  const bingoLink =
    document.querySelector<HTMLAnchorElement>(bingoLinkSelector);

  if (!bingoLink) {
    return;
  }

  try {
    const bingoId = await fetchBingoId(storeCountryCode());

    if (!bingoId) {
      return;
    }

    bingoLink.classList.replace(hiddenClass, visibleClass);
  } catch (error) {
    console.error('Could not resolve bingo availability for the header', error);
  }
};
